import request from '../../../helpers/request';

const getReceipt = async (offices, periodDate) => {
  const response = await request.get(
    `/RentPlace/receipt`,
    { offices: offices?.map((office) => office.id), periodDate },
    'При выгрузке квитанций произошла ошибка'
  );
  if (response?.data) {
    const data = Buffer.from(response.data, 'base64');
    const url = window.URL.createObjectURL(new Blob([data]));
    return [url, response?.fileName];
  }
  return [];
};

export default getReceipt;
